import { LocationInfo } from 'src/cordovaPlugins/Location';

import {
  enableLongFormKeyboard,
  enableSimpleKeyboard,
  resetKeyboard,
} from '../cordovaPlugins/Keyboard';
import {
  askForLocationPermissionsAfterDenial,
  permissions$,
  requestHighAccuracyLocationPermission,
  requestLocationBackgroundPermission,
  requestLocationInUsePermission,
} from '../cordovaPlugins/Permissions';
import { FluxType } from '../flux/buildFlux';
import { Keyboard } from './Device';
import { LocationService } from './LocationService';
import { OneSignal } from './OneSignal';
import { PushMessageHandler } from './PushMessageHandler';
import { AppServices, WlService } from './Service';

abstract class ServicesWithLocation extends WlService {
  protected getLocation: () => Promise<LocationInfo>;

  constructor(protected flux: FluxType) {
    super(flux);
    const { lastLocation$, getLocation } = this.start(
      'LocationService',
      LocationService,
    );
    this.location$ = lastLocation$;
    this.getLocation = getLocation;
  }
}

export class Services extends ServicesWithLocation {
  build(): AppServices {
    this.start('Keyboard', Keyboard);

    const oneSignalService = this.start('OneSignal', OneSignal);
    const { startPush, pushEvents$ } = this.start(
      'PushMessageHandler',
      PushMessageHandler,
      { oneSignalService },
    );

    return {
      permissions$,
      pushEvents$,
      location$: this.location$,
      locationFunctions: {
        getLocation: this.getLocation,
      },
      permissionFunctions: {
        startPush,
        requestLocationBackgroundPermission,
        requestLocationInUsePermission,
        requestHighAccuracyLocationPermission,
        askForLocationPermissionsAfterDenial,
      },
      keyboard: {
        resetKeyboard,
        useLongFormKeyboard: enableLongFormKeyboard,
        useSimpleKeyboard: enableSimpleKeyboard,
      },
    };
  }
}
